// TODO: Import React module
import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
import QRCode from 'react-qr-code';
import html2canvas from 'html2canvas';

// TODO: Import MUI module
import { Box, Rating, Typography } from '@mui/material';

// TODO: Import MUI icon
import { WbSunny, WbSunnyOutlined, WaterDrop, WaterDropOutlined } from '@mui/icons-material';

// TODO: Import context
import { Webservices } from '../../../Common/Context';

// TODO: Import custom component
import { WebservicesYiYuan } from '../../../Common/Context';

import BoardBackground from './BoardBackground.png';

const BoxIntroBoard = ({ id }) => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component BoxIntroBoard Rendered');

    // TODO: Define variable
    const [info, setInfo] = React.useState({});
    const [searchParams] = useSearchParams();
    const isAdmin = searchParams.get('admin') === 'true';

    const printArea = React.useRef();

    // TODO: Define event
    const handlePrint = () => {
        const box = printArea.current;
        if (box) {
            html2canvas(box, { useCORS: true }).then(canvas => {
                const link = document.createElement('a');
                link.download = `${info.Name}.png`;
                link.href = canvas.toDataURL();
                link.click();
            });
        }
    };

    React.useEffect(() => {
        const formData = new FormData();
        formData.append('action', 'GetIntroBoard');
        formData.append('id', id);

        fetch(WebservicesYiYuan, { method: 'POST', body: formData, })
            .then((response) => response.json())
            .then((result) => {
                setInfo(result);
            })
            .catch((error) => { console.error('Error:', error); });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    // TODO: Return component
    return (
        isAdmin &&
        <Box
            onClick={handlePrint}
            ref={printArea}
            sx={{
                backgroundImage: `url(${BoardBackground})`,
                backgroundSize: 'contain',
                width: '16cm',
                height: '16cm',
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                <QRCode
                    bgColor="transparent"
                    size={10}
                    style={{ height: "auto", width: "50%" }}
                    value={`https://www.pohtyh.edu.hk/CD_BlessedBotanicals?plant=${id}`}
                    viewBox={`0 0 10 10`}
                />
            </Box>
            <Typography sx={{
                color: 'success.dark',
                fontFamily: 'JasonHandwriting1',
                fontSize: '5rem',
                fontWeight: 'bold',
                mx: 2,
                textAlign: 'center',
            }}>
                {info.Name}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Rating
                    value={parseInt(info.Water)}
                    emptyIcon={<WaterDropOutlined fontSize="inherit" />}
                    icon={<WaterDrop fontSize="inherit" />}
                    readOnly
                    sx={{ color: '#05F', fontSize: '56px' }}
                />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Rating
                    value={parseInt(info.Sunshine)}
                    emptyIcon={<WbSunnyOutlined fontSize="inherit" />}
                    icon={<WbSunny fontSize="inherit" />}
                    readOnly
                    sx={{ color: '#F50', fontSize: '56px' }}
                />
            </Box>
        </Box>
    );
};

export default BoxIntroBoard;